import { render, staticRenderFns } from "./trigger_block.vue?vue&type=template&id=3c951330&"
import script from "./trigger_block.vue?vue&type=script&lang=js&"
export * from "./trigger_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports